export default __webpack_public_path__ + "static/media/arrow-right-disabled.2a3eff6a.svg";